import { Stack, Typography } from '@mui/material';

import { TrendBadgeDelta } from '@occc/ui-design-system';
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  EmptyDataTable,
} from '@occc-app/design-system';
import { RetailerNetworkTobaccoManufacturerOfferPerformanceFragment } from '@occc/graphql';

import {
  formatInt,
  formatUsdCents,
} from '../../retailer-network-tobacco-scan-data-page/components/tobacco-submissions.utils';

export type RetailerNetworkTobaccoOffersTableProps = {
  data: RetailerNetworkTobaccoManufacturerOfferPerformanceFragment[];
  title: string;
};

export const RetailerNetworkTobaccoOffersTable = ({
  data,
  title,
}: RetailerNetworkTobaccoOffersTableProps) => (
  <Stack>
    {title && (
      <Typography variant='body2' py={2}>
        {title}
      </Typography>
    )}

    <TableContainer component={undefined}>
      <Table>
        <TableHead>
          <TableRow hover={false}>
            <TableCell sx={{ '&&': { paddingLeft: 0 }, width: '35%' }}>Offer Name</TableCell>
            <TableCell sx={{ width: '20%' }}>Stores</TableCell>
            <TableCell sx={{ width: '20%' }}>Redemptions</TableCell>
            <TableCell align='right' sx={{ width: '25%' }}>
              Estimated Reimbursement
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!data.length && (
            <TableRow hover={false} sx={{ '&:last-child td': { border: 0 } }}>
              <TableCell colSpan={4}>
                <EmptyDataTable />
              </TableCell>
            </TableRow>
          )}
          {data.map((offer) => (
            <TableRow
              key={`${offer.offerName}-${offer.redemptions}-${offer.totalStores}`}
              hover={false}
              sx={{ '&:last-child td': { border: 0 } }}
            >
              <TableCell sx={{ '&&': { paddingLeft: 0 } }}>
                <Typography variant='body2'>{offer.offerName}</Typography>
              </TableCell>
              <TableCell>
                <Typography variant='body2'>{formatInt(offer.totalStores)}</Typography>
              </TableCell>
              <TableCell>
                <Typography variant='body2'>{formatInt(offer.redemptions)}</Typography>
              </TableCell>
              <TableCell>
                <Stack direction='row' alignItems='center' spacing={1} justifyContent='flex-end'>
                  <TrendBadgeDelta
                    value={
                      offer.estimatedReimbursements.loyalty +
                      offer.estimatedReimbursements.multiUnit
                    }
                    prevValue={
                      offer.previousEstimatedReimbursements.loyalty +
                      offer.previousEstimatedReimbursements.multiUnit
                    }
                  />
                  <Typography variant='body2'>
                    {formatUsdCents(
                      offer.estimatedReimbursements.loyalty +
                        offer.estimatedReimbursements.multiUnit,
                    )}
                  </Typography>
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Stack>
);
